import { postJSON, post, get } from '../utils/axios'

// 工单-报价单详情
export const selectSaleBillDetailByPk = (receiveCarPk: string, orgPk?: string) => post('pickCar/selectSaleBillDetailByPk', { receiveCarPk, orgPk })

// 更新车主确认报价状态
export const updateCarOwnerConfirmStatus = (receiveCarPk: string, orgPk?: string) => post('pickCar/updateCarOwnerConfirmStatus', { receiveCarPk, orgPk, confirmNotCancelPk: '' })

// 按车辆+进店里程查询保养方案列表
interface selectMaintainPlanListProps {
    carNo?: string //车牌号
    mileage?: string //进店里程
    receivePk?: string //接车单pk
}
export const selectMaintainPlanList = (options:selectMaintainPlanListProps) => post('maintainPlan/selectMaintainPlanList', options)

//按车牌查询商机列表
export const selectBoListByCarNo = (options:selectMaintainPlanListProps) => post('bo/selectBoListByCarNo', options)

//删除开单
interface ItemData {
    maintainPlanDetailPk?: string //保养方案明细pk
    relationPk?: string //关联pk
    itemPk?: string //服务/商品id
    itemName?: string //服务/商品名称
    relationItemPk?: string //商品关联服务id
}
interface addSaleBillProps {
    receivePk?: string //接车单pk
    detailList?: ItemData[] //明细列表
}
export const delSaleBill = (options:addSaleBillProps) => postJSON('maintainPlan/delSaleBill', options)

//添加开单
export const addSaleBill = (options:addSaleBillProps) => postJSON('maintainPlan/addSaleBill', options)

//查询车辆保养记录
interface selectMaintainRecordListByCarNoProps {
    searchValue?: string //查询条件
    carNo?: string //车牌号
    mileage?: string //进店里程
    receivePk?: string //接车单pk
}
export const selectMaintainRecordListByCarNo = (options:selectMaintainRecordListByCarNoProps) => postJSON('maintainPlan/selectMaintainRecordListByCarNo', options)

//工单详情
export const selectReceiveCarBillDetailByPk = (receiveCarPk:string) => post('pickCar/selectReceiveCarBillDetailByPk', { receiveCarPk })

//按车牌统计历史消费服务类型列表
export const consumeTypeList = (carNo:string) => post('pickCar/consumeTypeList', { carNo })

//查询车辆最后一次保养记录
export const selectLastNaintainRecordByCarNo = (carNo:string) => post('pickCar/selectLastNaintainRecordByCarNo', { carNo })

//按车牌查询历史检测未处理的异常检测项目列表
export const selectReportUnConversionItemListByCarNo = (carNo:string) => post('checkReport/selectReportUnConversionItemListByCarNo', { carNo })

//检测方案页面统计
interface checkPlanStatisticsProps {
    carNo?: string //车牌号
    mileage?: string //进店里程
}
export const checkPlanStatistics = (options:checkPlanStatisticsProps) => post('checkPlan/checkPlanStatistics', options)

//按车辆+进店里程查询检测方案列表
interface checkPlanStatisticsProps {
    carNo?: string //车牌号
    mileage?: string //进店里程
    receivePk?: string //接车单pk
}
export const selectCheckPlanList = (options:checkPlanStatisticsProps) => post('checkPlan/selectCheckPlanList', options)

//添加开单
interface checkPlanAddSaleBillProps {
    receivePk?: string //接车单pk
    servicePk?: string //检测服务pk
    serviceName?: string //检测服务名称
}
export const checkPlanAddSaleBill = (options:checkPlanAddSaleBillProps) => postJSON('checkPlan/addSaleBill', options)

//删除开单
export const checkPlanDelSaleBill = (options:checkPlanAddSaleBillProps) => postJSON('checkPlan/delSaleBill', options)

//智能提醒统计
interface expireRemindProps {
    carNo?: string //车牌号
    userPk?: string //客户pk
}
export const expireRemind = (options:expireRemindProps) => post('report/expireRemind', options)

//车主行为统计
interface owneBhaviorStatisticsProps {
    userPk?: string //客户pk
}
export const owneBhaviorStatistics = (options:owneBhaviorStatisticsProps) => post('report/owneBhaviorStatistics', options)

//接待备注与嘱咐列表
export const selectReceptionRemarkList = (options:expireRemindProps) => post('report/selectReceptionRemarkList', options)

//APP-导出结算单PDF
export const exportSettlementBill = (options?) => get('makeBill/exportSettlementBill', options)

// 获取小程序消息封面图列表；coverType 不传则返回全部
export const miniProgramCover = () => get('/yme-gewe/miniProgramCover/list', {
    coverType: '5'
})
